import { render, staticRenderFns } from "./TextType.vue?vue&type=template&id=5fa8ab46&"
import script from "./TextType.vue?vue&type=script&lang=js&"
export * from "./TextType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports